interface OsMeta {
  id: string;
  label: string;
  iconClass: string;
}

const osAndroid = {
  id: "android",
  label: "Android",
  iconClass: "fa-android",
};
const osChrome = {
  id: "cros",
  label: "ChromeOS",
  iconClass: "fa-chrome",
};
const osLinux = {
  id: "linux",
  label: "Linux",
  iconClass: "fa-linux",
};
const osMac = {
  id: "mac",
  label: "MacOS",
  iconClass: "fa-apple",
};
const osWeb = {
  id: "webos",
  label: "WebOS",
  iconClass: "fa-tv",
};
const osWindows = {
  id: "win32",
  label: "Windows",
  iconClass: "fa-windows",
};

const osMetaMap: Record<string, OsMeta> = {};
const rawOsMetaMap = {
  osAndroid,
  osChrome,
  osLinux,
  osMac,
  osWeb,
  osWindows,
};

Object.values(rawOsMetaMap).forEach((osMeta) => {
  osMetaMap[osMeta.id] = osMeta;
});

export default osMetaMap;
export { osAndroid, osChrome, osLinux, osMac, osWeb, osWindows };
